var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPasswordLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.35303 8.91618C2.35303 7.89026 3.20895 7.05859 4.26479 7.05859H15.7354C16.7912 7.05859 17.6471 7.89026 17.6471 8.91618V16.9657C17.6471 17.9916 16.7912 18.8233 15.7354 18.8233H4.26479C3.20895 18.8233 2.35303 17.9916 2.35303 16.9657V8.91618Z",
    fill: "#DCE1E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99983 2.15701C8.32794 2.15701 6.91666 3.53112 6.91666 5.29426V7.6472H5.29395V5.29426C5.29395 2.72576 7.36994 0.588379 9.99983 0.588379C12.6297 0.588379 14.7057 2.72576 14.7057 5.29426V7.6472H13.083V5.29426C13.083 3.53112 11.6717 2.15701 9.99983 2.15701Z",
    fill: "#DCE1E5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordLock);
export default __webpack_public_path__ + "static/media/PasswordLock.e38fe74e29d1c1163e74b3ccb57adcc5.svg";
export { ForwardRef as ReactComponent };